import React from 'react';
import { Box, Typography, Link, Container, Paper } from '@mui/material';
import { Helmet } from 'react-helmet';

const SupportPage = () => {
  return (
    <Box>
      <Helmet>
        <title>Support - HawkClient</title>
        <meta
          name="Support"
          content="Need help with HawkClient? Contact support or raise issues on GitHub."
        />
      </Helmet>

      <Container maxWidth="sm" sx={{ mt: 6 }}>
        <Paper elevation={3} sx={{ padding: 4, borderRadius: 2 }}>
          <Typography variant="h4" gutterBottom>
            Support
          </Typography>

          <Typography variant="body1" paragraph>
            If you have any questions, feedback, or need help with HawkClient, feel free to reach out:
          </Typography>

          <Typography variant="body1">
            📧 Email us at:{' '}
            <Link href="mailto:support@hawkclient.com" underline="hover">
              support@hawkclient.com
            </Link>
          </Typography>

          <Typography variant="body1" sx={{ mt: 2 }}>
            🐛 Found a bug or want to request a feature? Raise an issue on{' '}
            <Link
              href="https://github.com/prashantrathi123/hawkClient/issues"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
            >
              GitHub Issues
            </Link>
            .
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default SupportPage;
